




const sideData = [
   {
      name:'Home',
      path:'/dashboard/',
      icon:'fas fa-home'
   },
   /*{
     name:'Device types',
     path:'/dashboard/device_types',
     icon:'fas fa-venus-mars'
   },*/
   {
     name:'Devices Store',
     path:'/dashboard/device_store',
     icon:'fas fa-cloud'
   },
   {
     name:'Devices',
     path:'/dashboard/devices',
     icon:'fas fa-microchip'
   },
   {
    name:'Users',
    path:'/dashboard/users',
    icon:'fas fa-user'
   },
   {
    name:'Merchants',
    path:'/dashboard/merchants',
    icon:'fas fa-users'
   },
   {
    name:'Blocks',
    path:'/dashboard/blocks',
    icon:'fas fa-university'
   },
   {
    name:'Suspected Bypass',
    path:'/dashboard/suspected_bypass',
    icon:'fas fa-fire-extinguisher'
   },
   {
    name:'Alarm',
    path:'/dashboard/alarm',
    icon:'fas fa-bell'
   },
   {
    name:'Gen logs',
    path:'/dashboard/genlogs',
    icon:'fas fa-list'
   }
]

export default sideData;